export const BUTTON_VARIANT_CLASS_NAMES = {
  unstyled: '',
  primary: 'primary-button',
  secondary: 'secondary-button',
  ghost: 'ghost-button',
  danger: 'danger-button',
  confirmDanger: 'confirm-action-button tone-danger',
  confirmDismiss: 'secondary-button confirm-action-dismiss-button',
  confirmPrimary: 'confirm-action-button tone-primary',
  metricChartPoint: 'student-metrics-activity-point',
	mediaImageViewer: 'media-image-viewer-trigger',
  signIn: 'login-wireframe-submit',
  subscriptionTrial: 'primary-button subscription-trial-cta',
  subscriptionTrialParentPortal: 'secondary-button portal-home-login-action portal-home-login-action--parent subscription-trial-portal-action',
  subscriptionTrialStudentPortal: 'secondary-button portal-home-login-action portal-home-login-action--student subscription-trial-portal-action',
  icon: 'icon-button',
  adminPrimary: 'admin-agent-primary-button',
  adminAnalyticsReport: 'analytics-link-button',
  adminDanger: 'admin-topic-delete-button',
  adminSecondary: 'admin-agent-retry-button',
  adminFilter: 'admin-curriculums-filter',
  metricsSource: 'metrics-source-tab',
  parentAddChildSubmit: 'primary-button parent-add-child-submit',
  parentLearnerArchive: 'parent-learner-archive-action',
  parentLearnerSave: 'primary-button',
  parentBillingInline: 'parent-billing-inline-action',
  parentPrint: 'parent-print-btn',
  parentMockResult: 'parent-exam-card parent-exam-reviewable parent-mock-result-button',
  parentPaperResult: 'parent-exam-card parent-exam-reviewable parent-paper-result-button',
  parentResultBack: 'parent-result-back-btn',
  parentSelector: 'parent-selector-button',
  sidebar: 'app-sidebar-menu-button',
  studentCurriculumAction: 'student-curriculum-action',
  studentCurriculumFooterAction: 'student-curriculum-footer-action',
  studentExamBack: 'student-exam-back-button',
  studentExamHeroPrimary: 'student-exam-hero-primary',
  studentExamListAction: 'student-results-history-action student-exam-list-action',
  studentExamSearchClear: 'student-exam-list-search-clear',
  studentExamSearchSubmit: 'student-exam-list-search-submit',
  studentHomeNext: 'primary-button student-home-next-action',
  studentMockExamCancelConfirm: 'student-mock-exam-cancel-confirm',
  studentMockExamCancelKeep: 'student-mock-exam-cancel-keep',
  studentMockExamFooter: 'student-mock-exam-footer-button',
  studentMockExamGuideClose: 'student-mock-exam-guide-close',
  studentMockExamGuideReopen: 'student-mock-exam-guide-reopen',
  studentMockExamHeaderCancel: 'student-mock-exam-header-cancel',
  studentMockExamHeaderStart: 'student-mock-exam-header-start',
  studentMockExamPauseConfirm: 'student-mock-exam-pause-confirm student-mock-exam-submit-confirm',
  studentMockExamSolutionReveal: 'student-mock-exam-solution-reveal',
  studentMockExamSubmitConfirm: 'student-mock-exam-submit-confirm',
  studentResultPrimary: 'student-result-primary-button',
  studentResultSecondary: 'student-result-secondary-button',
  studentResultTableAction: 'student-result-table-action',
  studentResultsHistoryAction: 'student-results-history-action',
  studentResultsHistoryFilter: 'student-results-history-filter',
  studentResultsHistoryPage: 'student-results-history-page-button',
  studentSettingsModalPrimary: 'student-settings-modal-primary',
  studentSettingsModalSecondary: 'student-settings-modal-secondary',
};

export function joinButtonClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export function getButtonClassName({ className = '', variant = 'primary' } = {}) {
  const variantClassName = Object.prototype.hasOwnProperty.call(BUTTON_VARIANT_CLASS_NAMES, variant)
    ? BUTTON_VARIANT_CLASS_NAMES[variant]
    : variant;
  return joinButtonClassNames(variantClassName, className);
}
